module.exports = __webpack_public_path__ + "img/foot-xcx.8ed279d3.png";